import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckSquareFill, EyeSlash, PlayFill, Square } from "react-bootstrap-icons";
import sizeMe from "react-sizeme";
import "./ReplayPreview.scss";
import NumberFormat from "react-number-format";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

import {
  AspectRatio,
  assets,
  Avatars,
  Cards,
  HandEventType,
  handSlug,
  nFormatter,
  ReplayerPreferredSeats,
  RoomTypeIcons,
  slug
} from "../../api/ReplayVariables";
import PlayerWindowPositions from "../../api/PlayerWindowPositions";
import { getRepositionedSeat } from "../../api/ReplayPlayer";
import Votes from "../replay-app/Votes";
import { ChanelSelectionContext } from "../chanel/ChanelSelection";

function ReplayPreview({
  hand,
  size,
  className = "",
  log = false,
  featured = false,
  onClicked = () => {}
}) {
  const [refWidth, setRefWidth] = useState(340);
  const [refHeight, setRefHeight] = useState(340 / 1.504);

  const backgroundRef = React.createRef();

  // v2-1574: on the owner's channel, while he selects, a click selects the replay instead of opening it
  const selection = useContext(ChanelSelectionContext);
  const register = selection !== null ? selection.register : null;
  const unregister = selection !== null ? selection.unregister : null;
  const selecting = selection !== null && selection.active;
  const selected = selecting && selection.selected.indexOf(hand.id) !== -1;
  const handleClick = (evt) => {
    if (selecting) {
      evt.preventDefault();
      selection.toggle(hand.id);
    } else {
      onClicked(evt);
    }
  };
  useEffect(() => {
    if (register === null) {
      return;
    }
    register(hand.id);
    return () => unregister(hand.id);
  }, [register, unregister, hand.id]);

  let background = assets["background" + hand.background];

  const { t } = useTranslation();

  const letters = [
    "a",
    "z",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "q",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "w",
    "x",
    "c",
    "v",
    "b",
    "n"
  ];

  const getAvatar = (pseudo) => {
    let letter = pseudo.substring(0, 1).toLowerCase();
    if (letters.indexOf(letter) !== -1) {
      return Avatars["avatar" + letter.toUpperCase()];
    } else {
      return Avatars.avatarA;
    }
  };

  const action = hand.actions[0];
  const preferredSeat = ReplayerPreferredSeats["seats" + hand.nbSeats];
  let mainSeat = 0;
  action.players.forEach((player) => {
    if (player.pseudo === hand.hero) {
      mainSeat = player.seat;
    }
  });
  const realTableRatio = refWidth / AspectRatio.refWidth;

  const buttonSeat = getRepositionedSeat(
    hand.buttonSeat,
    hand.nbSeats,
    preferredSeat,
    mainSeat
  );
  const buttonTop =
    PlayerWindowPositions[hand.nbSeats + "_" + buttonSeat + "_buttonTop"] *
    realTableRatio;
  const buttonLeft =
    PlayerWindowPositions[hand.nbSeats + "_" + buttonSeat + "_buttonLeft"] *
    realTableRatio;

  const convertToFixed = (inputnum) => {
    var mynum = inputnum.toFixed(2);
    var mynumstr = mynum.toString();
    return parseFloat(mynumstr);
  };

  const nbBB = convertToFixed(action.potSize / hand.bigBlind, 1);

  const linkUrl = "/w/" + handSlug(hand);
  const chanelLinkUrl =
    "/c/" + slug(hand.user_name) + "-" + hand.user_id + "/home";

  useEffect(() => {
    if (log) {
      console.log(
        "backgroundRef.offsetWidth",
        backgroundRef.current.offsetWidth
      );
    }
    setRefWidth((r) => backgroundRef.current.offsetWidth);
    setRefHeight((h) => backgroundRef.current.offsetWidth / 1.504);
    backgroundRef.current.style.height =
      backgroundRef.current.offsetWidth / 1.504 + "px !important";

    return () => {
      //console.log("preview done");
    };
  }, [backgroundRef, size, log]);

  return (
    <div
      className={
        "replay-preview d-flex flex-column " +
        className +
        (selecting ? " selectable" : "") +
        (selected ? " selected" : "")
      }
    >
      <Link
        onClick={handleClick}
        to={linkUrl}
        className="preview"
        ref={backgroundRef}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage:
            background !== null && background !== undefined
              ? `url(${background})`
              : `url(${assets.backgroundDark2})`,
          height: refHeight + "px"
        }}
      >
        {hand.fullSession ?
          <div className="full-session">FULL</div> : ""}
        {selecting ? (
          <div className="selection-mark">{selected ? <CheckSquareFill /> : <Square />}</div>
        ) : (
          <></>
        )}
        <div className= {"room "+hand.roomType}>
          <img src={RoomTypeIcons[hand.roomType]} alt={hand.roomType} />
        </div>
        <div className="replay-button-container">
          <button>
            <PlayFill></PlayFill>
          </button>
        </div>
        <img
          className="preview-table"
          src={
            assets["table" + hand.table]
              ? assets["table" + hand.table]
              : assets.table1
          }
          alt="poker table"
        />
        <div className="preview-board" style={{ width: refWidth + "px" }}>
          <div className="preview-board-cards d-flex">
            {action.cards.map((card, index) => {
              if (card > 0)
                return (
                  <img
                    key={"board" + index}
                    className={"card" + (index + 1)}
                    src={Cards["card" + card]}
                    style={{
                      width: Math.ceil(32 * realTableRatio * 2) + "px",
                      height: Math.ceil(43 * realTableRatio * 2) + "px",
                      margin: "0 " + Math.ceil(2 * realTableRatio * 2) + "px"
                    }}
                    alt=""
                  />
                );
              else
                return (
                  <img
                    key={"board" + index}
                    className={"card" + (index + 1)}
                    src={Cards["cardEmpty"]}
                    style={{
                      width: Math.ceil(32 * realTableRatio * 2) + "px",
                      height: Math.ceil(43 * realTableRatio * 2) + "px",
                      margin: "0 " + Math.ceil(2 * realTableRatio * 2) + "px"
                    }}
                    alt=""
                  />
                );
            })}
          </div>
        </div>
        <div
          className="preview-dealer"
          style={{
            top: buttonTop + "px",
            left: buttonLeft + "px",
            lineHeight: AspectRatio.refLineHeight * realTableRatio + "px",
            fontSize: AspectRatio.refFontSize * realTableRatio + "px"
          }}
        >
          &nbsp;&nbsp;D&nbsp;&nbsp;
        </div>
        <table
          className="preview-pot"
          style={{
            /*
                            top: top + "px",
                            left: left + "px",
                            width: AspectRatio.refPlayerWidth * realTableRatio + "px",
                            */
            lineHeight: AspectRatio.refLineHeight * realTableRatio * 2 + "px",
            fontSize: AspectRatio.refFontSize * realTableRatio * 2 + "px"
          }}
        >
          <tbody>
            <tr>
              <td width="50%" align="right">
                &nbsp;POT
              </td>
              <td width="50%" align="left">
                &nbsp;
                <NumberFormat
                  value={nbBB}
                  displayType={"text"}
                  thousandSeparator={true}
                  renderText={(value) => <>{value}</>}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {action.players.map((player) => {
          let top =
            PlayerWindowPositions[
              hand.nbSeats +
                "_" +
                getRepositionedSeat(
                  player.seat,
                  hand.nbSeats,
                  preferredSeat,
                  mainSeat
                ) +
                "_top"
            ] * realTableRatio;
          if (top <= 0) {
            top = 1;
          }
          let left =
            PlayerWindowPositions[
              hand.nbSeats +
                "_" +
                getRepositionedSeat(
                  player.seat,
                  hand.nbSeats,
                  preferredSeat,
                  mainSeat
                ) +
                "_left"
            ] * realTableRatio;
          if (left <= 0) {
            left = 1;
          }
          let className = "";
          let actionVisible = player.eventType === HandEventType.COLLECT;
          if (player.playing) {
            if (player.current) {
              if (player.eventType === HandEventType.FOLD) {
                className = "player current folded";
              } else {
                className = "player current";
              }
            } else {
              className = "player";
            }
          } else {
            if (player.pseudo === hand.hero) {
              className = "player hero folded";
            } else {
              className = "player folded";
            }
          }

          if (player.pseudo === "") {
            className += " empty";
          }

          return (
            <div
              key={"player-" + player.pseudo + "-" + player.seat}
              className={
                "d-flex justify-content-center flex-column " + className
              }
              style={{ position: "absolute", top: top, left: left }}
            >
              <div className="d-flex">
                {player.cards.map((card, index) => (
                  <img
                    key={index}
                    src={
                      Cards[
                        (player.cards.length > 2 &&
                        index < player.cards.length - 1
                          ? "cardPreview"
                          : "card") +
                          (card !== -1 &&
                          (player.showedCards || player.pseudo === hand.hero)
                            ? card
                            : "Unknown")
                      ]
                    }
                    style={{
                      width:
                        Math.ceil(
                          (player.cards.length > 2 &&
                          index < player.cards.length - 1
                            ? 10
                            : 23) *
                            realTableRatio *
                            2
                        ) + "px",
                      height: Math.ceil(30 * realTableRatio * 2) + "px",
                      margin:
                        (player.cards.length <= 2
                          ? "0 " + Math.ceil(2 * realTableRatio * 2)
                          : "0") + "px"
                    }}
                    alt=""
                  />
                ))}
              </div>
              {actionVisible ? (
                <div
                  className="preview-action"
                  style={{
                    lineHeight:
                      AspectRatio.refLineHeight * realTableRatio * 2 + "px",
                    fontSize:
                      AspectRatio.refFontSize * realTableRatio * 2 + "px"
                  }}
                >
                  {t("replayApp.winner")}
                </div>
              ) : (
                <></>
              )}
            </div>
          );
        })}

        {!featured ? (
          <Votes key={hand.id} hand={hand} preview={true}></Votes>
        ) : (
          <></>
        )}
      </Link>
      <div className="details d-flex">
        <Link
          onClick={handleClick}
          to={chanelLinkUrl}
          className="owner-details-container d-flex flex-column align-items-center"
        >
          {hand.user_avatar ? (
            <img
              className="avatar-image"
              src={
                window.serverUrl+"/media/kunena/avatars/" +
                hand.user_avatar
              }
              alt="avatar"
            />
          ) : (
            <img className="avatar" src={getAvatar(hand.user_name)} alt="" />
          )}
          <div className="name">{hand.user_name}</div>
        </Link>
        <div className="details-inner d-flex flex-column">
            <Link onClick={handleClick} to={linkUrl} className="title">
            {hand.visibility === 0 ? <EyeSlash></EyeSlash>:<></>}
            {hand.sessionName.trim()}
          </Link>
          <Link onClick={handleClick} to={linkUrl} className="date">
            {new Intl.DateTimeFormat(i18n.language, {
              year: "numeric",
              month: "short",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            }).format(hand.startDate)}
          </Link>
          <div className="replay-owner d-flex flex-column">
            <div className="d-flex flex-row align-items-center">
              <Link onClick={handleClick} to={linkUrl} className="views">
                {nFormatter(hand.views)}{" "}
                {t(hand.views > 1 ? "replayApp.views" : "replayApp.view")} -{" "}
                <NumberFormat
                  value={hand.nb_comments}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalScale="0"
                  renderText={(value) => <>{value}</>}
                />{" "}
                {t(
                  hand.nb_comments > 1
                    ? "replayApp.comments"
                    : "replayApp.comment"
                )}
              </Link>
            </div>
            <div className="d-flex flex-row align-items-center">
              <Link onClick={handleClick} to={linkUrl} className="views">
                {nFormatter(hand.votes)}{" "}
                {t(
                  hand.votes > 1
                    ? "replayApp.votes.plural"
                    : "replayApp.votes.singular"
                )}
              </Link>
            </div>
          </div>
          {featured ? (
            <Link onClick={handleClick} to={linkUrl} className="votes-link">
              <Votes
                key={hand.id}
                hand={hand}
                preview={false}
                featured={true}
              ></Votes>
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}

export default sizeMe({
  monitorHeight: true,
  monitorWidth: true
})(ReplayPreview);
